import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowLeft = () => {
  return (
    <g>
      <path d="m5.545 2.147-.084.073L.22 7.468a.751.751 0 0 0-.073.977l.073.084 5.244 5.251a.749.749 0 0 0 1.133-.977l-.073-.084-3.962-3.971H15.25a.75.75 0 0 0 .102-1.493l-.102-.007H2.56L6.52 3.28a.751.751 0 0 0 .073-.977l-.072-.084a.749.749 0 0 0-.976-.073z" />
    </g>
  );
};

export default withIcon(IconArrowLeft);
